/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_Basis_RentInputs */

const cs_deal_provision_basis_rent = /** @type {(inputs: Deal_Provision_Basis_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měsíční nájem × 12`)
};

const en_deal_provision_basis_rent = /** @type {(inputs: Deal_Provision_Basis_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly rent × 12`)
};

/**
* | output |
* | --- |
* | "Monthly rent × 12" |
*
* @param {Deal_Provision_Basis_RentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_basis_rent = /** @type {((inputs?: Deal_Provision_Basis_RentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_Basis_RentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_basis_rent(inputs)
	return cs_deal_provision_basis_rent(inputs)
});